// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'chat-unavailable';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M8.437 12.938a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0zm6.187-1.688-3.375 3.375m.001-3.375 3.374 3.375' />
    <path d='m6.167 14.925-3.354 2.513v-3.375H1.687a1.125 1.125 0 0 1-1.125-1.126V1.688A1.125 1.125 0 0 1 1.688.563h14.626a1.125 1.125 0 0 1 1.125 1.125v5.625' />
  </g>
);

export const viewBox = '0 0 18 18';
